import {UserInterface} from '../../modules/auth/models/UserModel'
import {ID, Timestamps} from '../../../global'
import {getDefaultNamedEntity, NamedEntity, Subscriber} from '../global'

export interface WebFormsDashboardData {
  status: NamedEntity[]
  dataTable: WebFormsDataTable[]
  categorie: NamedEntity[]
  cards: WebFormsCards
}

export interface WebFormsDataTable {
  title: string
  created_at: string
  firstName: string
  lastName: string
  data: any
  date: string
  form_id: number
  status: string
  id: number
  notes: string
  message: string
  clients_id: number
  detail: string
  name_categories: string
  subscriber?: Subscriber
  data_from: 'wp' | 'wf'
}

export const initialValuesWebFormsDataTable: WebFormsDataTable = {
  title: '',
  created_at: '',
  firstName: '',
  lastName: '',
  data: '{}',
  date: '',
  form_id: 0,
  status: '',
  id: 0,
  clients_id: 0,
  name_categories: '',
  notes: '',
  message: '',
  detail: '',
  subscriber: undefined,
  data_from: 'wp'
}

export interface WebFormsCards {
  formsReceived: number
  formsProcessed: number
  responseRate: number
}

export const initialValuesWebFormsCards: WebFormsCards = {
  formsReceived: 0,
  formsProcessed: 0,
  responseRate: 0,
}

export const initialValuesWebFormsDashboardData: WebFormsDashboardData = {
  status: [getDefaultNamedEntity()],
  dataTable: [],
  categorie: [getDefaultNamedEntity()],
  cards: initialValuesWebFormsCards,
}

export type formSelectedType = {selected: string; params: {type: string}, formId: ID}


// ------------------------------------------------------------- V1

export interface WebFormStatus extends NamedEntity {
  bg: string;
}

export interface WebFormForm extends Timestamps {
  id: ID;
  data: string;
  form_id: number;
  from_host?: any;
  message?: any;
  notes: string;
  replay_at?: any;
  status: string;
  trait_at: string;
  forms?: WebFormForms;
  users?: UserInterface;
}

export interface WebFormCategories extends NamedEntity, Timestamps {
  index_?: number;
}

// Form Details
export interface WebFormForms extends Timestamps {
  id: ID;
  categorie_id: number;
  clients_id: number;
  title: string;
  client?: any;
  categories: WebFormCategories;
}

export const initialValuesWebFormForm: WebFormForm = {
  id: -1,
  form_id: -1,
  data: "",
  created_at: "",
  updated_at: "",
  status: "",
  notes: "",
  message: null,
  replay_at: null,
  trait_at: "",
  from_host: null,
}
export const WebFormBgStatusMap = new Map<string, string>([
  ['0', 'danger'],
  ['1', 'primary'],
  ['2', 'success'],
  ['3', 'info'],
]);

export const initialValuesWebFormStatus: WebFormStatus[] = [
  {id: "0", name: "À traiter", bg: "danger"},
  {id: "1", name: "En cours", bg: "primary"},
  {id: "2", name: "Finalisé", bg: "success"},
  {id: "3", name: "Ré-ouverture", bg: "info"}
]
export const initialValuesWebFormExcel = {
  formSelected: ""
}
